module.exports = __webpack_public_path__ + "img/more.accdb7bb.svg";